import { isEmpty } from "lodash";
import { getDictionary } from "../utilities/utilities";
import { Validate } from "./Validate";
import { buildLocationLabel } from "../pages/AddressBook/utilities";

const dictionary = getDictionary();

export interface Location {
  id: string;
  creationDate: string;
  creationUser: string;
  lastModifiedDate: string;
  lastModifiedUser: string;
  municipality: string;
  countryIsoCode3: string;
  subRegion: string;
  subRegionName: string;
  district: string;
  houseNumber: string;
  label: string;
  languageCode: string;
  matchLevelCode: string;
  postalCode: string;
  region: string;
  regionName: string;
  street: string;
  unit: string;
  latitude: number;
  longitude: number;

  registryId?: string; //FE
}

export interface CreateLocation {
  countryIsoCode3: string;
  languageCode: string;
  matchLevelCode: string;
  label?: string;
  municipality?: string;
  subRegion?: string;
  subRegionName?: string;
  district?: string;
  houseNumber?: string;
  postalCode?: string;
  region?: string;
  regionName?: string;
  street?: string;
  unit?: string;
  latitude?: number;
  longitude?: number;
}

export interface UpdateLocation extends CreateLocation {
  id: string;
  municipality?: string;
  subRegion?: string;
  subRegionName?: string;
  district?: string;
  houseNumber?: string;
  label?: string;
  postalCode?: string;
  region?: string;
  regionName?: string;
  street?: string;
  unit?: string;
  latitude?: number;
  longitude?: number;
}

// Convert function to create
export const convertLocationToCreate = (location: Location): CreateLocation => {
  return {
    countryIsoCode3: location.countryIsoCode3,
    languageCode: location.languageCode,
    matchLevelCode: location.matchLevelCode,
    label: buildLocationLabel(location),
    municipality: location.municipality,
    subRegion: location.subRegion,
    subRegionName: location.subRegionName,
    district: location.district,
    houseNumber: location.houseNumber,
    postalCode: location.postalCode,
    region: location.region,
    regionName: location.regionName,
    street: location.street,
    unit: location.unit,
    latitude: location.latitude,
    longitude: location.longitude,
  };
};

// Convert function to update
export const convertLocationToUpdate = (location: Location): UpdateLocation => {
  return {
    id: location.id,
    countryIsoCode3: location.countryIsoCode3,
    languageCode: location.languageCode,
    matchLevelCode: location.matchLevelCode,
    municipality: location.municipality,
    subRegion: location.subRegion,
    subRegionName: location.subRegionName,
    district: location.district,
    houseNumber: location.houseNumber,
    label: buildLocationLabel(location),
    postalCode: location.postalCode,
    region: location.region,
    regionName: location.regionName,
    street: location.street,
    unit: location.unit,
    latitude: location.latitude,
    longitude: location.longitude,
  };
};

export const validate = (location: Location): Validate => {
  const validate: Validate = { isValid: true, errors: {} };
  if (!location.street) {
    validate.errors.street = dictionary.messages.mandatory_field;
  }
  if (!location.countryIsoCode3) {
    validate.errors.countryIsoCode3 = dictionary.messages.mandatory_field;
  }
  if (!location.languageCode) {
    validate.errors.languageCode = dictionary.messages.mandatory_field;
  }
  if (!location.matchLevelCode) {
    validate.errors.matchLevelCode = dictionary.messages.mandatory_field;
  }

  if (!isEmpty(validate.errors)) {
    validate.isValid = false;
  }

  return validate;
};
